import ContentDetailPage from './ContentDetailPage';
export default ContentDetailPage;
